import axios from "axios";
import store from "app/redux/store";
import jwt from "jwt-decode";
import { setAuthUser, setAuthToken } from "app/redux/authReducer";

const clientFormData = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 3600000,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
  },
});

clientFormData.interceptors.request.use(
  (config) => {
    const token = store.getState()?.auth.token?.accessToken || "";
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
        "Access-Control-Allow-Origin": "*",
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

clientFormData.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    if (err.response?.status === 400) {
    }
    if (originalConfig?.url !== "/auth/signin" && err.response) {
      if (err.response.status === 401) {
        originalConfig._retry = true;
        try {
          const data = {
            refreshToken: store.getState()?.auth.token?.refreshToken || "",
          };
          if (data.refreshToken) {
            const res = await clientFormData.post(
              "auth/refresh-token",
              JSON.stringify(data)
            );
            const user = jwt(res.data.data.accessToken);
            const token = {
              accessToken: res.data.data.accessToken,
              refreshToken: res.data.data.refreshToken,
            };
            store.dispatch(setAuthUser(user));
            store.dispatch(setAuthToken(token));
            return clientFormData(originalConfig);
          }
        } catch (_error) {
          const token = {
            accessToken: null,
            refreshToken: null,
          };
          store.dispatch(setAuthUser(null));
          store.dispatch(setAuthToken(token));

          return Promise.reject(_error);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default clientFormData;
